<div class="h-full bg-background-white">
  <div class="flex h-full">
    <div class="relative z-10 flex w-[320px] flex-col justify-between rounded-br-3xl bg-text-white px-10 py-4 shadow-side-button">
      <div class="flex flex-col gap-4">
        <div class="mb-11 flex items-center">
          <img class="h-[48px] w-[48px] items-center" src="assets/images/logo-beta-header.svg" width="48" height="48" />
          <span class="ml-2 text-[26px] text-text-light">{{ 'site_setup_setup' | translate }}</span>
        </div>
        <div class="flex items-center gap-2 rounded-2xl bg-background-light-blue px-3 py-2 font-semibold text-text-black">
          {{ 'site_setup_external_sign' | translate }}
        </div>
      </div>

      <a
        class="flex items-center gap-2 rounded-2xl px-3 py-2 text-text-blue"
        [routerLink]="[routes.help]"
        [queryParamsHandling]="'preserve'"
        routerLinkActive
        #rla="routerLinkActive"
        [class.active]="rla.isActive"
      >
        <div class="typo-h5-book flex h-6 w-6 items-center justify-center rounded-full border">?</div>
        <span class="font-semibold">{{ 'site_setup_help' | translate }}</span>
      </a>
    </div>
    <div class="w-full overflow-scroll px-[160px]">
      @if (vm().contract?.state === DataState.Loading) {
        <div class="flex h-full items-center justify-center">
          <ng-lottie currentColor class="text-text-blue" [options]="lottieOptions"></ng-lottie>
        </div>
      } @else {
        <router-outlet></router-outlet>
      }
    </div>
  </div>
</div>
